import { render, staticRenderFns } from "./kdorder.vue?vue&type=template&id=acdeeaa2&scoped=true&"
import script from "./kdorder.vue?vue&type=script&lang=js&"
export * from "./kdorder.vue?vue&type=script&lang=js&"
import style0 from "./kdorder.vue?vue&type=style&index=0&id=acdeeaa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdeeaa2",
  null
  
)

export default component.exports